angular.module('ui.order.stepDetailedRouteContainer', [])

    .config(function ($stateProvider) {
        $stateProvider.state('client.step', {
            url: '/orders/:step/details/:orderItemId?',
            templateUrl: 'app/ui/order/stepDetailedView/stepDetailedRouteContainer/stepDetailedRouteContainer.html',
            data: {pageTitle: 'OrderManager: Item details'},
            controller: 'StepDetailedRouteContainerController',
            controllerAs: 'StepDetailedRouteContainerController'
        });
    })

    .controller('StepDetailedRouteContainerController', function ($scope, $stateParams, orderItemsGridSharedSettings) {
        orderItemsGridSharedSettings.setStepFilter($stateParams.step);

        //If we have exact order item Id supplied in the url - this means we want to show this exact item exclusively
        if ($stateParams.orderItemId) {
            var parsedItemId = 0;
            try {
                parsedItemId = parseInt($stateParams.orderItemId);
            } catch (e) {
                //Just ignore the Id if it's not a valid number
            }

            if (parsedItemId > 0) {
                orderItemsGridSharedSettings.setSelectedOrderItemId(parsedItemId, true);
            }
        }
    })

;
